/**
 * Created by zhj on 3/14/2016.
 */
'use strict';

angular.module('telephone')
  .service('telephoneService', function (crudService, $q) {
    var model = 'telephones';

    this.getTelephoneList = function () {
      return crudService.getList(model+'/telephoneindexlist');
    };

    this.getNewTelephone = function () {
      var telephone = {
        key: null,
        firstName: null,
        lastName: null,
        fullName: null,
        telephoneNumber: null
      };
      var deferred = $q.defer();
      deferred.resolve(telephone);
      return deferred.promise;
    };

    this.getTelephoneDetail = function (details) {
       if(details.key)
       {
        return crudService.get(model, details.key);     
       }     
       return crudService.get(model, details.telephoneNumber);
    };

    this.getCopyTelephone = function (key) {
      return crudService.get(model, key).then(function (telephone) {
        telephone.resourceID = null;
        return telephone;
      });
    };

    this.saveTelephone = function (telephoneDetail) {
      return crudService.post(model,telephoneDetail);
    };

    this.updateTelephone = function (telephoneDetail) {
      return crudService.put(model, telephoneDetail);
    };

    this.deleteTelephone = function (telephoneDetail) { 
      if(telephoneDetail.key){   
        return crudService.delete(model + '/' + telephoneDetail.key );             
      }
      return crudService.delete(model + '/' + telephoneDetail.telephoneNumber );
      //return crudService.delete(model + '/' + telephoneDetail.name +'/' + telephoneDetail.telephoneNumber);
    };

    this.checkUserRight = function () {
        return crudService.get(model+'/checkdownload');
    };

    this.checkPhoneDBRight = function () {
      return crudService.get(model+'/phonedbright');
    };
    this.importTelephone = function(encodedFileString){
      return crudService.post(model+'/import',encodedFileString);
    };
    this.getTelephoneAclRight = function(){
       return  crudService.get(model+'/resourceaclright');
    };
    this.getPendingCommandsAclRight = function(){
      return  crudService.get(model+'/pendingcmndaclright');
    };

  });



// WEBPACK FOOTER //
// ./.tmp/components/track/telephone/telephoneService.js